import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  login: [],
  verify: [],
  signoutt: [],
};

const AuthSlice = createSlice({
  name: "Auth",
  initialState,
  reducers: {
    loginRequest: (state, action) => {
      state.loading = true;
      state.error = null;
      state.login = [];
    },
    loginSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.login = action.payload;
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.login = [];
    },

    verifyRequest: (state, action) => {
      state.loading = true;
      state.error = null;
      state.verify = [];
    },
    verifySuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.verify = action.payload;
    },
    verifyFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.verify = [];
    },

    signoutRequest: (state, action) => {
      state.loading = true;
      state.error = null;
      state.signoutt = [];
    },
    signoutSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.signoutt = action.payload;
    },
    signoutFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.signoutt = [];
    },
  },
});

export const AuthAction = AuthSlice.actions;
export default AuthSlice;
